export const baseFormColumn = (ctx) => {
  return [
    {
      prop: 'approvalType',
      name: '审批类型',
      type: 'select',
      currentValue: ctx.approvalType,
      options: [
        { value: '01', label: '常规' },
        { value: '02', label: '手动冻结' },
        { value: '03', label: '解冻申请' },
        { value: '04', label: '解押申请' },
        { value: '05', label: '创建申请' },
      ],
      span: 12,
      disabled: true,
    },
    {
      prop: 'stockQuantity',
      name: '在库库存',
      type: 'inputAmount',
      span: 12,
      disabled: true,
    },
    {
      prop: 'reason',
      name: '原因',
      type: 'select',
      options: ctx.frozeReasonList,
      currentValue: ctx.frozeReason,
      span: 12,
      disabled: true,
      isHidden: ctx.isHideFrozeReason,
    },
    {
      prop: 'safeStockQuantity',
      name: '安全库存',
      type: 'inputAmount',
      span: 12,
      disabled: true,
    },
    {
      prop: 'outStockQuantity',
      name: '出库数量',
      type: 'inputAmount',
      span: 12,
      disabled: true,
      isHidden: ctx.idHideOutStockQuantity,
    },
    {
      prop: 'canUseStockQuantity',
      name: '可用库存',
      type: 'inputAmount',
      span: 12,
      disabled: true,
    },
    {
      prop: 'approvalComment',
      name: '审批意见',
      type: 'input',
      span: 24,
    },
  ];
};

export const baseFormRules = () => {
  return {
    approvalComment: [{ required: true, message: '审批意见必填', trigger: ['change', 'blur'] }],
  };
};
